import { type StaticImageData } from 'next/image'

import { LOCALE } from '../../../domain/i18n/LOCALE'
import { type PublicGlobalConfig } from '../../global-config/config-types/PublicGlobalConfig'

import modalHero_CH_DE from './images/nl_banner_ch_de.webp'
import modalHero_CH_FR from './images/nl_banner_ch_fr.webp'
import modalHero_FR from './images/nl_banner_fr.webp'
import modalHero_IT from './images/nl_banner_it.webp'

export const getNewsletterModalHero = (
  globalConfig: PublicGlobalConfig,
): StaticImageData => {
  switch (globalConfig.locale) {
    case LOCALE.DE_CH: {
      return modalHero_CH_DE
    }
    case LOCALE.FR_CH: {
      return modalHero_CH_FR
    }
    case LOCALE.FR_FR: {
      return modalHero_FR
    }
    case LOCALE.IT_IT: {
      return modalHero_IT
    }
    default: {
      return modalHero_CH_DE
    }
  }
}
